module.exports = __webpack_public_path__ + "static/media/congenital-malformation-and-abnormality-icon.e399045e.svg";